import { useEffect, useRef, useState } from "react";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";
import { TextInput } from "@shared/text-input";

interface Props {
  isOpen: boolean;
  onAdd: (value: string) => void;
  onClose: () => void;
}

export const PromotionCalendarCampaignTypeModal = ({
  isOpen,
  onAdd,
  onClose,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (isOpen) {
      setValue("");
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      bodyClassName="min-w-[500px]"
      titleContent="Create a new campaign type"
      onClose={() => onClose()}
    >
      <div className="mt-2 mb-4 px-[1px]">
        <TextInput
          ref={inputRef}
          autoFocus={true}
          label="CAMPAIGN TYPE NAME"
          placeholder="Type..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div className="flex items-center justify-end gap-2">
        <TertiaryButton className="font-bold" onClick={() => onClose()}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          disabled={value === ""}
          className="font-bold flex items-center gap-2"
          onClick={() => onAdd(value)}
        >
          SAVE
        </PrimaryButton>
      </div>
    </Modal>
  );
};
